module.exports = __webpack_public_path__ + "static/media/location_map_white.7a449fd2.svg";